
import { useState, useEffect } from 'react';
import API from '../api/api';
import useSignOut from 'react-auth-kit/hooks/useSignOut';

const useGetSubjects = (role) => {

    const [subjects, setList] = useState([]);
    const [subjects_error, setError] = useState(null);
    const [subjects_loading, setLoading] = useState(true);


    useEffect(() => {
        const loadData = async () => {
            try {
                const request = await API.get('/get_subjects');
                if (request.data.data) {
                    setList(request.data.data);
                } 
            }
            catch(error) {
              if (error?.status === 401) {
                  return;
                }
                if (error.status === 403) {return;} 
              setError(error);
          }
            finally {
                setLoading(false);
            }
        }
        loadData();
    }, [role]) 
    
    return { subjects, subjects_loading, subjects_error };
}

export default useGetSubjects;